import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacilityListComponent } from './facility-list/facility-list.component';
import { FacilityEditComponent } from './facility-edit/facility-edit.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularMaterialModule, QuidelCoreModule } from '../../core';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FacilityDeletionImpactDialogComponent } from './facility-deletion-impact-dialog/facility-deletion-impact-dialog.component';

@NgModule({
  declarations: [FacilityListComponent, FacilityEditComponent, FacilityDeletionImpactDialogComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    QuidelCoreModule,
    TranslateModule,
    ScrollingModule
  ],
  exports: [
    FacilityListComponent,
    FacilityEditComponent
  ]
})
export class FacilityModule { }
